export enum ActionItemType {
  ACTION_ITEM_NEW = 'ACTION_ITEM_NEW',
  ACTION_ITEM_UPDATE = 'ACTION_ITEM_UPDATE',
  ISSUE_UPDATE = 'ISSUE_UPDATE',
}


